
const SuperOgPanels = {
    Welcome: 0,
    Lobby: 1,
    NewChallenge: 2,
    AcceptChallenge: 3,
    Results: 5,
    Alert: 6,
    ShowReel: 7,
    ShowReelReplay: 8,
}
export default SuperOgPanels;